// ─── Net ("to 1") odds games ────────────────────────────────────────────────
//
// Sic Bo's feed quotes the NET price in `b` — the board prints 50:1, 30:1, 1:1
// and so on, and that is what the original site shows everywhere.
//
// The bet still has to be PLACED at the decimal price b+1: settlement pays
// stake × odds, so the raw net price would hand an even-money winner zero
// profit (the 2026-09-19 money fix). So the decimal goes to the server, and the
// net price comes back out for every number the player reads — bet slip, My Bet
// list, result modal, account statement.
//
// Baccarat works the same way — its boxes print 1:1, 8:1, 11:1, 25:1 — Tie too
// (8 to 1 → placed at 9, like the reference). Tie bets placed before that were
// stored @8 and paid 7×, so they read 7.
export const NET_ODDS_GAMES = new Set(["sicbo", "sicbo2", "baccarat", "baccarat2"]);

export function isNetOddsGame(gameName) {
  return NET_ODDS_GAMES.has(String(gameName || "").toLowerCase());
}

/** Decimal price (b+1) → the net price the board quotes (b). */
export function toNetOdds(decimal) {
  const n = parseFloat(decimal) || 0;
  return n > 1 ? Math.round((n - 1) * 100) / 100 : n;
}

/** Stored odds → what the player should read, for one game.
 *  Used wherever only the saved bet row is available (My Bet, result modal,
 *  account statement); a live click has `item.b` and can use it directly. */
export function displayNetOdds(gameName, storedOdds) {
  if (!NET_ODDS_GAMES.has(String(gameName || "").toLowerCase())) return storedOdds;
  return toNetOdds(storedOdds);
}
